import { FC } from 'react';
import loader from '../assets/images/loader.svg';
import styles from './Spinner.module.scss';

interface SpinnerProps {
  description?: string;
}

const Spinner: FC<SpinnerProps> = ({
  description = '',
}: {
  description?: string;
}) => {
  return (
    <div className={`loader ${styles.loader}`}>
      <img src={loader} alt='loader' />
      <p className={styles.text}>{description ?? ''}</p>
    </div>
  );
};

export default Spinner;
